// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    name: 'test',
    production: false,
    version: '2026.10.22.5',
    build: 0,
    websiteTitle: 'sa.gov.au',
    productTitle: 'sa.gov.au',
    options: {
        formVault: {
            enabled: false,
            showFormIds: false
        }
    },
    config: {
        swEnabled: false,
        autofocus: false,

        remoteServiceBaseUrl      : '',

        // ENDPOINTS: are the service handler endpoint, and do NOT include method references.
        // These are used in Service Proxies as the Base URL for individual APIs.
        formServiceEndpoint       : '/iSolutions.Forms.Service/FormService.asmx',
        dashboardServiceEndpoint  : '/iSolutions.Dashboard.Service/FormService.asmx',
        securityEndpoint          : '/iSolutions.Security.Service/SecurityService.asmx',
        workflowEndpoint          : '/iSolutions.Forms.Service/FormService.asmx',
        aggregationServiceEndpoint: '/iSolutions.DataAggregation.Service/DataAggregationService.asmx',
        arcGISProxyEndpoint       : '/iSolutions.Security.Service/CorsProxyHandler.ashx',
        avatarEndpoint            : '/iSolutions.Workbench.Service/FormAvatarHandler.ashx',
        csvEndpoint               : '/iSolutions.Forms.Service/CsvExportHandler.ashx',
        csvExternalEndpoint       : '/Csv.External.WebServices/CsvExternalServices.asmx',
        dataProxyEndpoint         : '/iSolutions.Forms.Service/DataProxyService.asmx',
        docgenEndpoint            : '/iSolutions.DocumentManager.Service',
        fileListEndpoint          : '/iSolutions.Files.Service/FileManagerService.asmx',
        fileUploadEndpoint        : '/iSolutions.Files.Service/FileContentsHandler.ashx',
        googleMapEndpoint         : '/iSolutions.Forms.Service/GoogleMapHandler.ashx',
        paymentServiceEndpoint    : '/iSolutions.Forms.Service/PaymentService.asmx',
        zipEndpoint               : '/iSolutions.Forms.Service/FileContentsHandlerZip.ashx',

        googleMapApiKey: '',
        callOfflineSyncProductsTimeoutMinutes: 5
    },
    security: {
        userProfileUrl              : '/user/profile',
        loginTimeoutEnabled         : true,
        loginTimeoutDuration        : 90, // seconds
        showTimeoutProgress         : true,
        // authenticationMode: 'hybrid', // 'internal', 'external', 'hybrid'
        authenticationMode          : 'internal',
        allowSelfRegistration       : true,
        authenticationConfirmation  : true
    },
    exceptionless: {
        enabled                   : false,
        apiKey                    : "",
        host                      : "",
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
